require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-internet-of-things-idea-lab.json") })
        }
      }, "path---blog-internet-of-things-idea-lab");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-internet-of-things-idea-lab!./.cache/json/blog-internet-of-things-idea-lab.json
// module id = 903
// module chunks = 231608221292675